export const LogoMark = ({ className = "h-8", invert = false }) => (
  <img
    src="/img/goencho-logo.png"
    alt="goencho logo"
    className={`${className} w-auto ${invert ? "logo-invert" : ""}`}
  />
);

export const Logo = ({ invert = false }) => (
  <span className="inline-flex items-center gap-2.5">
    <LogoMark invert={invert} className="h-10 md:h-11" />
    <span className="font-display text-[26px] italic leading-none tracking-tight">goencho</span>
  </span>
);
